import { OrderAttributes, OrderDetailAttributes } from "@albatrosdeveloper/ave-models-package";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { PageEvent } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { CompanyService } from "../../configuration/company/company.service.service";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { UnitMeasureDisplayComponent } from "../../../../shared/components/unit-measure-display/unit-measure-display.component";

@Component({
  selector: "app-select-order-detail-modal",
  styleUrl: "./select-order-detail.component.scss",
  templateUrl: "./select-order-detail.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatSelectModule,
    MatTableModule,
    MatCheckboxModule,
    DecimalFormatPipe,
    UnitMeasureDisplayComponent
  ],
})
export class SelectOrderDetailComponent implements OnInit {
  
  displayedColumns: string[] = ['check', 'material', 'warehouse', 'soldQuantity', 'unitPrice', 'subTotal', 'totalSurcharges', 'totalDiscounts', 'totalTaxes', 'total'];
  dataSource = new MatTableDataSource<OrderDetailAttributes>([]);
  
  totalItems: number = 0;
  searchControl = new FormControl('');
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderDetailAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderDetailAttributes | null = null;
  
  @ViewChild("orderConfirmationDialog")
  orderConfirmationDialog!: TemplateRef<any>;
  
  UMPActive: boolean;

  constructor(
    private readonly companyService: CompanyService,
    public readonly dialogRef: MatDialogRef<SelectOrderDetailComponent>,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private readonly router: Router,
    @Inject(MAT_DIALOG_DATA) public data: {order: OrderAttributes, type: string},
  ) {
    
  }

  ngOnInit(): void {
    this.fetchCompanies();
    this.getList();
  }

  getList(){
    let detail = this.data?.order?.detail ?? [];
    this.dataSource.data = detail.filter(d => d?.statusId != 0);
    this.totalItems = this.data?.order?.detail?.length ?? 0;
  }

  openConfirmationDialog(): void {
    if(this.selection.selected.length == 0){
      return;
    }

    this.dialog
      .open(this.orderConfirmationDialog, {
        data: this.data,
        panelClass: "form-modal",
        disableClose: true,
        width: "400px"
      })
      .afterClosed()
      .subscribe((result) => result && this.onClone());
  }

  onClone(): void {
    let object = null;
    if(this.data.order.type.code == DocumentTypeEnum.COTIZACION){ //Cotizacion
      object = {
        cQuoteId: this.data.order._id.toString(),
        type: this.data.type,
        positions: this.selection.selected.map(d => d.position).toString(),
      }
      this.router.navigate(['master', 'sales', 'quotation-generate'], {queryParams: object});
      this.dialogRef.close();

    }else if(this.data.order.type.code == DocumentTypeEnum.PEDIDO){ //Pedido
      object = {
        cOrderId: this.data.order._id.toString(),
        type: this.data.type,
        positions: this.selection.selected.map(d => d.position).toString(),
      }
      this.router.navigate(['master', 'sales', 'order-generate'], {queryParams: object});
      this.dialogRef.close();
    }

  }

  
  onCheckboxChange(event, element?): void{
    
  }
  
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => {
      this.selection.select(row)
    });
  }

  isAllSelected() {
    const validRows = this.dataSource.data
    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;  
    return numSelected === numValidRows && numValidRows > 0;
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    //this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    //this.getList()
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive
      }
    });
  }
}